import { extendTheme } from '@chakra-ui/react';
import { Accordion } from './accordion';
import { Avatar } from './avatar';
import { Badge } from './badge';
import { Button } from './button';
import { Card } from './card';
import { Checkbox } from './checkbox';
import { colors } from './colors';
import { Divider } from './divider';
import { Drawer } from './drawer';
import { Form } from './form';
import { FormLabel } from './formLabel';
import { Heading } from './heading';
import { Input } from './input';
import { List } from './list';
import { Menu } from './menu';
import { Modal } from './modal';
import { NumberInput } from './numberInput';
import { Popover } from './popover';
import { Radio } from './radio';
import { Select } from './select';
import { Skeleton } from './skeleton';
import { Table } from './table';
import { Tabs } from './tabs';
import { Text } from './text';
import { Textarea } from './textarea';
import { Tooltip } from './tooltip';

export default extendTheme({
  styles: {
    global: {
      body: {
        fontSize: '14px'
      }
    }
  },
  breakpoints: {
    sm: '48em',
    md: '64em',
    lg: '80em',
    xl: '90em',
    '2xl': '120em',
    '3xl': '138em'
  },
  fonts: {
    body: 'Inter, Arial, sans-serif',
    heading: 'Inter, Arial, sans-serif'
  },
  components: {
    Accordion,
    Avatar,
    Badge,
    Button,
    Card,
    Checkbox,
    Divider,
    Drawer,
    Form,
    FormLabel,
    Heading,
    Input,
    List,
    Menu,
    Modal,
    NumberInput,
    Popover,
    Radio,
    Select,
    Skeleton,
    Table,
    Tabs,
    Text,
    Textarea,
    Tooltip
  },
  colors,
  shadows: {
    outline: 'none'
  }
});